/**
 * @param cssVariable
 * @returns
 */
export const getRawColor = (cssVariable: string): string => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    try {
      const rootStyle = getComputedStyle(document.documentElement)
      const value = rootStyle.getPropertyValue(cssVariable).trim()

      if (!value) {
        return getDefaultColor(cssVariable)
      }

      return value
    } catch (error) {
      return getDefaultColor(cssVariable)
    }
  }

  return getDefaultColor(cssVariable)
}

const getDefaultColor = (cssVariable: string): string => {
  const colorName = cssVariable.replace('--', '')

  const defaultColors: Record<string, string> = {
    white: '#ffffff',
    black: '#18191c',
    primary: '#ffdd2d',
    secondary: '#5baaff',
    red: '#ec1212',
    blue: '#5baaff',
    green: '#129958',
    grey: '#eff0f4',
    tertiary: '#9ea8b6',
    'background-grey': '#eff1f4',
    yellow: '#fdbd1a',
    orange: '#fc9e55',
    'grey-6': '#838795',
  }

  return defaultColors[colorName] || '#ffffff'
}
